import { FeatureNameEnum } from '../features';
import { NavigationItemInterface } from '../interfaces';
import { RoutesEnum } from '../routes';

export const compensationNavigationItem: Readonly<NavigationItemInterface> = {
  name: FeatureNameEnum.Compensation,
  route: RoutesEnum.Compensation,
  icon: 'credit_card',
};
